// PaymentResult.jsx
import React, { Fragment, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Parse from "../../API/ParseServer";
import Header from "../../Components/Layout/Header";
import { Box, Grid, Typography } from "@mui/material";
import { Grade } from "@mui/icons-material";
import Footer from "../../Components/Layout/Footer";

export default function PaymentResult() {
  const [searchParams] = useSearchParams();
  const [order, setOrder] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const sessionId = searchParams.get("session_id");

    const fetchOrderDetails = async () => {
      // console.log(sessionId);
      try {
        // 1. Find the Basket
        const Basket = Parse.Object.extend("Basket");
        const basketQuery = new Parse.Query(Basket).equalTo(
          "stripeSessionId",
          sessionId
        );

        const basket = await basketQuery.first();
        if (basket) {
          // 2. Find related Order
          const Order = Parse.Object.extend("Order");
          const orderQuery = new Parse.Query(Order).equalTo(
            "stripePaymentId",
            basket.get("paymentIntentId")
          );

          const order = await orderQuery.first();
          if (order) setOrder(order);
        }
        const user = Parse.User.current();
        if (user) {
          await user.fetch();
        }
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (sessionId) fetchOrderDetails();
  }, [searchParams]);

  if (loading) return <div className="loading">Loading payment details...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <div className="payment-result">
      {order ? (
        <Fragment>
          {order && (
            <Box sx={{ width: "90%", maxWidth: "30rem", margin: "2rem auto" }}>
              <Typography
                component="h1"
                variant="h4"
                sx={{ textAlign: "center", mb: 5 }}
              >
                Payment Successful!
              </Typography>
              <Grid
                container
                sx={{ border: "2px solid #863a18", p: 3, borderRadius: "20px" }}
              >
                <Grid item xs={5}>
                  <Typography variant="h6">Order Number</Typography>
                </Grid>
                <Grid item xs={7} sx={{ textAlign: "end" }}>
                  <Typography variant="h6">
                    {order.get("orderNumber")}
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  <Typography variant="h6">Total Amount</Typography>
                </Grid>
                <Grid item xs={7} sx={{ textAlign: "end" }}>
                  <Typography variant="h6">
                    £{order.get("totalAmount").toFixed(2)}
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  <Typography variant="h6">Ordered By</Typography>
                </Grid>
                <Grid item xs={7} sx={{ textAlign: "end" }}>
                  <Typography variant="h6">
                    {order.get("receiverName")}
                  </Typography>
                </Grid>
                <Grid item xs={5}>
                  <Typography variant="h6">Order Date</Typography>
                </Grid>
                <Grid item xs={7} sx={{ textAlign: "end" }}>
                  <Typography variant="h6">
                    {order.get("createdAt").toDateString()}
                  </Typography>
                </Grid>
              </Grid>
              <Link to={"/profile"}>
                {" "}
                <Typography
                  sx={{
                    textAlign: "center",
                    mt: 3,
                    mb: 30,
                    color: "#863a18",
                    cursor: "pointer",
                  }}
                  variant="h6"
                >
                  Go to Your Profile
                </Typography>
              </Link>
            </Box>
          )}
        </Fragment>
      ) : (
        <div className="payment-pending">
          <h2>Payment Processing...</h2>
          <p>
            Your payment is being processed. We'll update this page shortly.
          </p>
        </div>
      )}
    </div>
  );
}
